import {h, Component} from 'preact'

import AsideDesignAccents from './AsideDesignAccents'
import AsideFreeImages from './AsideFreeImages'
import AsideFreeVideos from './AsideFreeVideos'
import AsideIllustrations from './AsideIllustrations'
import AsideFrames from './AsideFrames'
import AsideBackgrounds from './AsideBackgrounds'
import AsideUploads from './AsideUploads'
import AsideShapes from './AsideShapes'
import AsideLogos from './AsideLogos'

import {connect} from 'react-redux'
import reduce from '../reducers'
import * as actions from '../actions'
import store from '../store'
import constants from '../constants'
import AsideQRCodes from './AsideQRCodes'
import util from '../util'
import AsidePOSUploads from "./AsidePOSUploads";

export default @connect(reduce, actions)
class AsideElements extends Component {
    constructor() {
        super();
    }

    viewDesignAccents () {
        this.goToView('accents')
    }

    viewUploads () {
        this.goToView('uploads')
    }

    viewPOSUploads () {
        this.goToView('pos-uploads')
    }

    viewLogos() {
        this.goToView('logos')
    }

    viewFreeImages () {
        this.goToView('free')
    }

    viewFreeVideos () {
        this.goToView('free-videos')
    }

    viewIllustrations () {
        this.goToView('illustrations')
    }

    viewFrames () {
        this.goToView('frames')
    }

    viewBackgrounds () {
        store.dispatch(actions.setColorPickerType(constants.pickerTypes.backgroundFill));
        this.props.goToView('color-picker');
    }

    viewShapes () {
        this.goToView('shapes')
    }

    goToView (view) {
        this.props.goToSubview(view)
    }

    goToRoot () {
        this.props.goToSubview('root')
    }


    render (props, state) {
        let content = null;

        switch (props.subview) {
            case 'accents':
                content = <AsideDesignAccents goToRoot={this.goToRoot.bind(this)} />;
                break;
            case 'shapes':
                content = <AsideShapes goToRoot={this.goToRoot.bind(this)} />;
                break;
            case 'free':
                content = <AsideFreeImages goToRoot={this.goToRoot.bind(this)} />;
                break;
            case 'free-videos':
                content = <AsideFreeVideos goToRoot={this.goToRoot.bind(this)} />;
                break;
            case 'illustrations':
                content = <AsideIllustrations goToRoot={this.goToRoot.bind(this)} />;
                break;
            case 'frames':
                content = <AsideFrames goToRoot={this.goToRoot.bind(this)} />;
                break;
            case 'backgrounds':
                content = <AsideBackgrounds goToRoot={this.goToRoot.bind(this)} />;
                break;
            case 'uploads':
                content = <AsideUploads 
                    goToRoot={this.goToRoot.bind(this)} 
                    uploadedImages={props.uploadedImages}
                    setUploadedImages={props.setUploadedImages}
                />;
                break;
            case 'pos-uploads':
                content = <AsidePOSUploads goToRoot={this.goToRoot.bind(this)}/>;
                break;
            case 'logos':
                content = <AsideLogos goToRoot={this.goToRoot.bind(this)} />;
                break;
            case 'qr-codes':
                content = <AsideQRCodes goToRoot={this.goToRoot.bind(this)} />;
                break;
            default:
                content =
                    <div className="link-images">
                        <ul>
                            <li className={(props.accents && (props.accents.illustrations.length > 0 || props.accents.images.length > 0)) && (props.isReplaceFrameMode) ? '' : 'hidden'}>
                                <a className="color" onClick={() => this.viewDesignAccents()}>
                                    <span className="icon">
                                        <svg><use xlinkHref={ constants.appPrefix + "/svg/icons.svg#app-design-accents" }/></svg>
                                    </span>
                                    <h6>Template Art</h6>
                                </a>
                            </li>
                            {(!props.isReplaceFrameMode || (props.isReplaceFrameMode)) && <li>
                                <a className="color" onClick={() => this.viewFreeImages()}>
                                    <span className="icon">
                                        <svg className="stock-photos-svg"><use xlinkHref={ constants.appPrefix + "/svg/icons.svg#app-free-photos" }/></svg>
                                    </span>
                                    <h6>Stock Photos</h6>
                                </a>
                            </li>}
                            {(util.isPixelDesign() && !props.isLogo && (!props.isReplaceFrameMode || (props.isReplaceFrameMode && util.isVideoFrame(props.$element))) || props.isDigitalMenuBoard) && <li>
                                <a className="color" onClick={() => this.viewFreeVideos()}>
                                    <span className="icon">
                                        <svg className="stock-videos-svg"><use xlinkHref={ constants.appPrefix + "/svg/icons.svg#app-free-videos" }/></svg>
                                    </span>
                                    <h6>Stock Videos</h6>
                                </a>
                            </li>}
                            {(!props.isReplaceFrameMode || (props.isReplaceFrameMode)) && <li>
                                <a className="color" onClick={() => this.viewIllustrations()}>
                                    <span className="icon">
                                        <svg><use xlinkHref={ constants.appPrefix + "/svg/icons.svg#app-illustrations" }/></svg></span>
                                    <h6>Illustrations</h6>
                                </a>
                            </li>}
                            {!props.isReplaceFrameMode && <li>
                                <a className="color" onClick={() => this.viewFrames()}>
                                    <span className="icon">
                                        <svg><use xlinkHref={ constants.appPrefix + "/svg/icons.svg#app-frames" }/></svg></span>
                                    <h6>Photo Area</h6>
                                </a>
                            </li>}
                            {!props.isReplaceFrameMode && (props.isDesigner || props.isAdmin) && <li>
                                <a className="color" onClick={() => this.viewBackgrounds()}>
                                    <span className="icon">
                                        <svg><use xlinkHref={ constants.appPrefix + "/svg/icons.svg#app-backgrounds" }/></svg></span>
                                    <h6>Background</h6>
                                </a>
                            </li>}
                            {!props.isReplaceFrameMode && <li>
                                <a className="color" onClick={() => this.viewShapes()}>
                                    <span className="icon">
                                        <svg><use xlinkHref={ constants.appPrefix + "/svg/icons.svg#app-shapes" }/></svg></span>
                                    <h6>Shapes</h6>
                                </a>
                            </li>}
                            {(!props.isReplaceFrameMode || (props.isReplaceFrameMode)) && <li>
                                <a className="color" onClick={() => this.viewLogos()}>
                                    <span className="icon">
                                        <svg><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-logos"}/></svg></span>
                                    <h6>
                                        My Logos
                                    </h6>
                                </a>
                            </li>}
                            <li>
                                <a className="color" onClick={() => this.viewUploads()}>
                                    <span className="icon">
                                        <svg><use xlinkHref={ constants.appPrefix + "/svg/icons.svg#app-uploads" }/></svg></span>
                                    <h6>My Uploads</h6>
                                </a>
                            </li>
                            <li>
                                <a className="color" onClick={() => this.viewPOSUploads()}>
                                    <span className="icon">
                                        <svg><use xlinkHref={ constants.appPrefix + "/svg/icons.svg#app-uploads" }/></svg></span>
                                    <h6>My POS Uploads</h6>
                                </a>
                            </li>
                        </ul>
                    </div>
        }

        return (
            <div  id="app-aside-graphics" className="aside-text">
                <div className="scroller no-top">
                    {content}
                </div>
            </div>
        )
    }
}
